import React, { useState } from 'react';
import './Navbars.css';
import { Link } from 'react-router-dom';
import IQAC from '../../../IQAC/Iqac';
import IIICFile from './IQAC DOCUMENT/IIIC cell of IQAC.pdf';
import committee from "./IQAC DOCUMENT/Committee of IQAC.pdf"
import Sc from "./IQAC DOCUMENT/Sc cell IQAC.pdf"
const Navbars = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleDropdown = (index) => {
    if (activeDropdown === index) {
      setActiveDropdown(null); 
    } else {
      setActiveDropdown(index); 
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); 
  };

  return (
    <nav className="navbar">
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar bar1 ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar bar2 ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar bar3 ${isMenuOpen ? 'open' : ''}`}></div>
      </div>
      
      <ul className={`navbar-links ${isMenuOpen ? 'show' : ''}`}>
        <li><Link to="/">HOME</Link></li>
        
        
        <li className="dropdown" onClick={() => toggleDropdown(0)}>
          <a href="#" className="dropdown-link">ABOUT US</a>
          {activeDropdown === 0 && (
            <ul className="dropdown-menu">
              <li><Link to="/OverView">OverView</Link></li>
              <li><Link to="/InfraStructure">InfraStructure</Link></li>
              <li><Link to="/Message">Message's</Link></li>
              <li><Link to="/Affiliation">Affiliation</Link></li>
              <li><Link to="/Vision_Mission">Vision Mission</Link></li>
            
            </ul>
          )}
        </li>

        
        <li className="dropdown" onClick={() => toggleDropdown(2)}>
          <a href="#" className="dropdown-link">ACADEMICS</a>
          {activeDropdown === 2 && (
            <ul className="dropdown-menu">
              <li><Link to="/curriculum">Curriculum</Link></li>
              <li><Link to="/faculty">Faculty</Link></li>
              <li><Link to="/admission">Admission</Link></li>
              <li><Link to="/Download">Download(Syllabus and Scheme)</Link></li>
            </ul>
          )}
        </li>

       
        <li className="dropdown" onClick={() => toggleDropdown(3)}>
          <a href="#" className="dropdown-link">DEPARTMENT</a>
          {activeDropdown === 3 && (
            <ul className="dropdown-menu">
              <li><Link to="/Dpharmacy">D.Pharmacy</Link></li>
              <li><Link to="/Lab">Lab</Link></li>
            </ul>
          )}
        </li>

       
        <li className="dropdown" onClick={() => toggleDropdown(4)}>
  {/* <a href="#" className="dropdown-link">IQAC(NAAC)</a>
  {activeDropdown === 4 && (
    <ul className="dropdown-menu">
      <li><Link to="/Iqac">ABOUT IQAC</Link></li> 
      <li>
      <a href={IIICFile} download>IIIC Cell of IQAC</a>
    </li>
      <li>
      <a href={committee} download>Committee of IQAC</a>
    </li>
      <li>
      <a href={Sc} download>Sc Cell of IQAC</a>
    </li>
      <li><Link to="/Report">ACTIVITY REPORT/FORM</Link></li>
   
      

    </ul>        
  )} */}
</li>


       
       
        {/* <li><Link to="/placement">PLACEMENT</Link></li> */}
        <li><Link to="/Course">COURSE</Link></li>
        <li><Link to="/NEWS">NEWS</Link></li> 
        {/* <li><Link to="/Latest_information">LATEST INFORMATION</Link></li> */}
        <li><Link to="/Gallery">GALLERY</Link></li>
      </ul>
    </nav>
  );
};

export default Navbars;
